import { render } from "./EditPart.vue?vue&type=template&id=aea9f824&scoped=true"
import script from "./EditPart.vue?vue&type=script&lang=js"
export * from "./EditPart.vue?vue&type=script&lang=js"

import "./EditPart.vue?vue&type=style&index=0&id=aea9f824&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea9f824"]])

export default __exports__